module.exports = __webpack_public_path__ + "img/section-01-anim-02-x2.800ed4d9.jpg";